// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3F746","label":"SetPasswdForm_label__17Zxf"};